// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__Z2xOq","emails":"CreateEditClinics_emails__2Bo7t","emailTagLabel":"CreateEditClinics_emailTagLabel__3Lb21"};